import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import SimpleCard from '../../../../../components/SimpleCard';
import SpaceTable from './SpaceTable';

export default function SpaceDimension({ spaceDimensions }) {
  return (
    <Grid container>
      <Grid item xs={12} md={2}>
        <Typography variant="h6" fontWeight="bold">
          Space Dimensions:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <SimpleCard>
          <Grid container>
            <SpaceTable spaceDimensions={spaceDimensions} />
          </Grid>
        </SimpleCard>
      </Grid>
    </Grid>
  );
}

SpaceDimension.propTypes = {
  spaceDimensions: PropTypes.arrayOf(
    PropTypes.shape({
      cost: PropTypes.number.isRequired,
      fk_event: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired,
      industry: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      space_number: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
};
